<template>
  <div>
    <a-config-provider :locale="locale">
      <div id="app">
        <router-view v-slot="{ Component }">
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </router-view>
      </div>
    </a-config-provider>
  </div>
</template>


<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');
export default {
  name: "App",
  components: {},
  data() {
    return {
      locale: zhCN
    }
  }
};
</script>

<style>
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
  background-color: #000b24;
}

.ant-table-thead>tr>th {
  background-color: #133964 !important;
  color: #fff !important;
  border-bottom: 1px #9fc6ef solid !important;
}

.ant-table-body>tr.ant-table-row:hover>td,
.ant-table-tbody>tr>td.ant-table-cell-row-hover {
  background-color: rgba(159, 199, 239, 0.5) !important;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector {

  color: #333;
}

.ant-input {

  background-color: #133964 !important;
  color: #fff !important;
  border: 1px #042954 solid !important;
}

input::placeholder {
  color: #f0f0f0 !important;
}

.ant-table-tbody>tr>td {
  border-bottom: 1px rgba(19, 57, 100, 0.5) solid !important;
}

.ant-layout {
  background-color: transparent !important;
  height: 100vh;
}

.ant-modal-content {
  background-color: #0d2a4b !important;
  border: 1px #2b85e4 solid !important;
}

.ant-modal-header {
  background-color: #0d2a4b !important;
  border-bottom: 1px #2b85e4 solid !important;
  color: #fff !important;
}

.ant-modal-footer {
  border-top: 1px #2b85e4 solid !important;
}

.ant-modal-title {
  color: #fff !important;
}

li {
  list-style: none;
}

.ant-layout-header {
  /* background: url("@/assets/u1.png") !important; */
  height: 110px !important;
  padding: 0 !important;
  overflow: hidden;
  margin-bottom: 30px;
  background: none !important;
}

.ant-select-selector {
  background-color: #133964 !important;
  color: #fff !important;
  border: 1px #042954 solid !important;
}

.ant-select-arrow {
  color: #fff !important;
}

.ant-form-item-label>label {
  color: #fff !important;
}

.ant-layout-content {
  flex: 1;
  overflow-y: auto;
  /*只是y方向*/
  /* background: url('~@/assets/pageBg.png'); */
}
</style>
